<template>
  <CheckoutStep>
    <template #aside>
      <CheckoutSummary
        :discount
        :discount-token
        :items
        :methods-features="['bouygues_in_store']"
        :selected-payment-method="paymentMethod"
        :summary
        :swapOffer
        with-extended-legal
      />
    </template>

    <template #header>
      <Stepper
        active-step="payment"
        @back="
          navigateTo({
            name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.ADDRESSES,
          })
        "
      />
    </template>

    <div aria-live="polite" role="status">
      <Payment
        :cancelUrl="currentUrl.toString()"
        :discount
        :failureUrl="currentUrl.toString()"
        :items
        :methods-features="['bouygues_in_store']"
        :result-page-name="
          CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.PAYMENT_RESULT
        "
        :summary
        :swap-offer
      />
    </div>
  </CheckoutStep>
</template>

<script setup lang="ts">
import { navigateTo, useRequestURL } from '#imports'
import { onMounted } from 'vue'

import type { BuybackOffer } from '@backmarket/http-api'
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import CheckoutStep from '@backmarket/nuxt-layer-checkout/components/CheckoutStep/CheckoutStep.vue'
import CheckoutSummary from '@backmarket/nuxt-layer-checkout/components/CheckoutSummary/CheckoutSummary.vue'
import { useCheckoutTracking } from '@backmarket/nuxt-layer-checkout/composables/useCheckoutTracking'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

import Payment from '~/scopes/checkout/components/Payment/Payment.vue'
import { CHECKOUT } from '~/scopes/checkout/routes-names'
import type { Discount } from '~/scopes/checkout/types/discount'

import Stepper from '../../components/Stepper/Stepper.vue'

const props = defineProps<{
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems']
  addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList']
  shippableCountries: ApiSpecs['/bm/cart']['GET']['response']['shippableCountries']
  summary: ApiSpecs['/bm/cart']['GET']['response']['summary']
  swapOffer: BuybackOffer | null
  discount: Discount
  discountToken: string
  loading: boolean
  paymentMethod: PaymentMethod | null
}>()

const { trackFunnel } = useCheckoutTracking()
const currentUrl = useRequestURL()

onMounted(async () => {
  trackFunnel(props.items, props.swapOffer)
})
</script>
